import { useParams } from "react-router";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "@refinedev/react-hook-form";

import { DiscountFormValues, discountSchema } from "@modules/discounts/validations/discountSchema";
import { useEditDiscountMutation } from "@modules/discounts/services/mutations";

export function useDiscountEditForm() {
  const { id } = useParams();
  const { mutateAsync, isPending } = useEditDiscountMutation(id as string);

  const methods = useForm<DiscountFormValues>({
    resolver: zodResolver(discountSchema()),
    defaultValues: {
      active: true,
    },
    mode: "onBlur",
  });

  const {
    handleSubmit,
    refineCore: { formLoading },
  } = methods;

  return {
    methods,
    handleSubmit,
    mutateAsync,
    isPending,
    formLoading,
    id,
  };
}
